import React from 'react';
import { StarIcon, ZapIcon, ShieldCheckIcon, InfinityIcon, RotateCcwIcon, EyeIcon, FlameIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { SmartImage } from './SmartImage';
import { pricing, productImage, bonusShortList } from '../data/offer';
const guarantees = [{
  icon: ZapIcon,
  label: 'Entrega inmediata'
}, {
  icon: ShieldCheckIcon,
  label: 'Pago seguro'
}, {
  icon: InfinityIcon,
  label: 'Acceso de por vida'
}, {
  icon: RotateCcwIcon,
  label: 'Garantía de 7 días'
}];
type HeroProps = {
  showScarcity: boolean;
};
export function Hero({
  showScarcity
}: HeroProps) {
  return <header className="w-full bg-forest-900 text-cream-100" data-id="element-97" data-mp="sde3ev8vjpwt">
      <div className="mx-auto grid max-w-content gap-7 px-5 pb-10 pt-8 sm:gap-10 sm:px-8 sm:pb-16 sm:pt-12 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:pb-24 lg:pt-16" data-id="element-98" data-mp="nb6lzq59zhn3">
        <div data-id="element-99" data-mp="381xjaspbqs7j">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.28em] text-moss-400 sm:text-xs" data-id="element-100" data-mp="381e1rd3l65u1">
            MegaPack Hábitos
          </p>
          <h1 className="mt-3 font-display text-[2rem] font-extrabold leading-[1.05] tracking-tight text-cream-50 sm:mt-5 sm:text-5xl lg:text-[3.75rem]" data-id="element-101" data-mp="3o7lrboupx2nw">
            En 21 días, construí una rutina de hábitos que puedas sostener
          </h1>
          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-moss-200 sm:mt-6 sm:text-lg" data-id="element-102" data-mp="3e8ecsyc8z1z7">
            Un plan diario simple y progresivo para dejar de empezar una y otra vez, ordenar tu
            rutina y convertir pequeñas acciones en hábitos que formen parte de tu día a día.
          </p>

          <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-[13px] text-moss-200 sm:mt-8 sm:gap-x-6 sm:gap-y-3 sm:text-sm" data-id="element-103" data-mp="2ql692kugw0za">
            <span className="flex items-center gap-1.5 font-semibold text-cream-100" data-id="element-104" data-mp="2hj5fbxyfzx2d">
              <StarIcon className="h-4 w-4 fill-moss-400 text-moss-400" aria-hidden="true" data-id="element-105" data-mp="2hl9q8zurdwc5" />
              4.9/5
            </span>
            <span aria-hidden="true" className="h-3.5 w-px bg-forest-600" data-id="element-106" data-mp="s2jmbumnjwig" />
            <span data-id="element-107" data-mp="s3umzlkswo5c">+500 ventas</span>
            <span aria-hidden="true" className="h-3.5 w-px bg-forest-600" data-id="element-108" data-mp="nb1jf112jluu" />
            <span className="flex items-center gap-1.5" data-id="element-109" data-mp="ibyqgeyd5638">
              <EyeIcon className="h-4 w-4" aria-hidden="true" data-id="element-110" data-mp="ichy92uaue3j" />
              22 personas viéndolo ahora
            </span>
          </div>
        </div>

        <div className="lg:pl-4" data-id="element-111" data-mp="1b1fel0eya0tn">
          <SmartImage src={productImage} alt="MegaPack Hábitos: caja del pack, versión para tablet y celular, diario de hábitos, guía práctica y las tarjetas de los recursos incluidos." width={1404} height={1131} sizes="(min-width: 1024px) 520px, 100vw" priority wrapperClassName="w-full rounded-xl border border-forest-700 shadow-[0_20px_50px_-28px_rgba(0,0,0,0.7)] sm:rounded-2xl" className="h-auto w-full object-cover" data-id="element-112" data-mp="1b0drtyoknpw3" />
        </div>
      </div>

      <div className="bg-cream-100 text-forest-900" data-id="element-113" data-mp="1x9kw0qpijcjb">
        <div className="mx-auto max-w-content px-5 py-8 sm:px-8 sm:py-12 lg:py-14" data-id="element-114" data-mp="1xb5pse406rg4">
          <div className="grid gap-7 lg:grid-cols-[1fr_auto] lg:items-end lg:gap-16" data-id="element-115" data-mp="21bpnpjwehz3b">
            <div data-id="element-116" data-mp="268y5hjdn0141">
              <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-moss-600 sm:text-xs sm:tracking-[0.18em]" data-id="element-117" data-mp="268g3e64amso7">
                Cupo de compra disponible por tiempo limitado
              </p>
              <div className="mt-2 flex flex-wrap items-baseline gap-3 sm:mt-4 sm:gap-4" data-id="element-118" data-mp="2fzj4h7x837nh">
                <span className="font-display text-xl font-semibold text-forest-800/50 line-through decoration-clay-500/70 decoration-2 sm:text-2xl" data-id="element-119" data-mp="2kxc9vyqpbxmp">
                  {pricing.regular}
                </span>
                <span className="font-display text-[2.75rem] font-extrabold leading-none tracking-tight text-forest-900 sm:text-6xl" data-id="element-120" data-mp="2tysf7s2nt9k2">
                  {pricing.today}
                </span>
              </div>

              <div className="mt-6 border-t border-cream-300 pt-5 sm:mt-8 sm:pt-6" data-id="element-121" data-mp="zndrfgt7lk6y">
                <p className="font-display text-[13px] font-bold uppercase tracking-[0.14em] text-forest-800 sm:text-sm sm:tracking-[0.16em]" data-id="element-122" data-mp="49jdu72hirn6">
                  Además, te llevás 5 bonos gratis
                </p>
                <ul className="mt-3 grid gap-x-8 gap-y-1.5 sm:mt-4 sm:grid-cols-2 sm:gap-y-2" data-id="element-123" data-mp="e77jvt5jjlkn">
                  {bonusShortList.map((bonus, index) => <li key={bonus} className="flex items-baseline gap-2.5 text-sm sm:gap-3 sm:text-[15px]" data-id="element-124" data-mp="3hrbu7ltckhwf" data-mpi={index}>
                      <span className="font-display text-[11px] font-bold tabular-nums text-moss-600" data-id="element-125" data-mp="3csil05l3fd22">
                        #{index + 1}
                      </span>
                      <span className="flex-1 text-forest-900" data-id="element-126" data-mp="3mou013c2ih07">{bonus}</span>
                      <span className="font-display text-[10px] font-bold uppercase tracking-wider text-moss-600 sm:text-[11px]" data-id="element-127" data-mp="2yzsubnumdjym">
                        Gratis
                      </span>
                    </li>)}
                </ul>
                <p className="mt-4 text-[13px] text-forest-800/70 sm:mt-5 sm:text-sm" data-id="element-128" data-mp="19h2q0hilpi4e">
                  Valor total: <span className="line-through" data-id="element-129" data-mp="1eayi53c6oarn">{pricing.totalValue}</span> · Hoy
                  pagás solamente{' '}
                  <span className="font-semibold text-forest-900" data-id="element-130" data-mp="zielmljjh1j6">{pricing.today}</span> · Ahorrás{' '}
                  <span className="font-semibold text-forest-900" data-id="element-131" data-mp="14h7ycbr04oia">{pricing.savings}</span>
                </p>
              </div>
            </div>

            <div className="w-full lg:w-[340px]" data-id="element-132" data-mp="1x8hx0nlbonlz">
              {showScarcity && <div className="mb-4 flex flex-wrap items-center gap-x-5 gap-y-1 rounded-xl bg-clay-100 px-4 py-3 sm:mb-5 sm:px-5 sm:py-4" data-id="element-133" data-mp="1j903jux30m6a">
                  <p className="flex items-center gap-2 text-[13px] font-semibold text-clay-600 sm:text-sm" data-id="element-134" data-mp="1n8h9epgf7lbz">
                    <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-135" data-mp="7s0bn0enc9cs" />
                    Quedan 7 cupos
                  </p>
                  <Countdown className="!text-[13px] sm:!text-sm" data-id="element-136" data-mp="2ehao3j5t2a4b" />
                </div>}
              <CtaButton data-id="element-137" data-mp="29hxr45l7zmo0">Quiero empezar hoy</CtaButton>
              <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs text-forest-800/80 sm:mt-5 sm:gap-x-4 sm:gap-y-2 sm:text-[13px]" data-id="element-138" data-mp="29j94mx4gw8sb">
                {guarantees.map(({
                icon: Icon,
                label
              }) => <li key={label} className="flex items-center gap-1.5 sm:gap-2" data-id="element-139" data-mp="1zql9s7x1sew8">
                    <Icon className="h-3.5 w-3.5 shrink-0 text-moss-600 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-140" data-mp="1vsnimzjpviq7" />
                    {label}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>;
}